import { action, observable } from "mobx";
import { message } from "antd";
import { STATUS_VALIDATION_ERROR } from "../../constants/http";
import ApiManager from "../../mixins/ApiManager";
import { DOWNLOAD_CMR, REFRESH_CMR_TABLE } from "../../constants/events";
import ee from "../../services/EventEmitter";
import { CreateCmrResponse } from "../../services/responses";

export type ErrorValueType = string[] | null;

interface IErrors {
  cmr_place?: ErrorValueType;
  cmr_date?: ErrorValueType;
}

class CreateCmrStore extends ApiManager {
  @observable
  private _errors: IErrors = {};

  @observable
  cmrNumber: string | undefined;

  get errors(): IErrors {
    return this._errors;
  }

  @action
  create(params: Object): Promise<CreateCmrResponse> {
    return this.apiManager
      .createCmr(params)
      .then(async (response) => {
        const data = await response.json();

        this._errors = {};

        message.success(data.message);

        ee.emit(REFRESH_CMR_TABLE, null);

        return data;
      })
      .catch(async (response) => {
        const data = await response.json();

        if (response.status === STATUS_VALIDATION_ERROR) {
          this._errors = data.errors;
        }

        message.error(data.message);

        return data;
      });
  }

  @action
  loadCmrNumber(): Promise<void> {
    return this.apiManager.getCmrNumber().then(async (response) => {
      const data = await response.json();

      if (data.cmr_number) {
        this.cmrNumber = data.cmr_number as string;
      }
    });
  }

  saveAndDownload(params: Object): Promise<number | null> {
    return this.create(params).then(async (data) => {
      if (data.entity && data.entity.id) {
        ee.emit(DOWNLOAD_CMR, {
          id: data.entity.id,
        });

        return data.entity.id;
      }

      return null;
    });
  }
}

export default CreateCmrStore;
